import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';

import {
    Button,
    Card,
    colors,
    Divider,
    ElvaLogoName,
    Inline,
    Input,
    Page,
    Stack,
    PasswordInput,
    Box,
    CommitSha,
    u,
} from '@ui';

import { useUserLogin, useUser } from '../../hooks';

import * as css from './UserLoginScreen.css';

type UserLoginScreenProps = {
    registerPath: string;
    resetPasswordPath: string;
};

export function UserLoginScreen({ registerPath, resetPasswordPath }: UserLoginScreenProps) {
    const { register, handleSubmit } = useForm<Record<'email' | 'password', string>>();
    const { isError, error } = useUser();
    const login = useUserLogin();
    const navigate = useNavigate();

    return (
        <Page>
            <Card>
                <Stack gap={u(2.5)}>
                    <Inline alignItems="center" justifyContent="space-between">
                        <Stack gap={u(0.5)}>
                            <h4>Login</h4>
                            <p style={{ fontSize: '0.8em', color: colors.gray[400] }}>Log in with your email</p>
                        </Stack>
                        <ElvaLogoName width={90} />
                    </Inline>
                    <Divider />
                    <form onSubmit={handleSubmit((data) => login.mutate(data))}>
                        <Stack gap={u(2.5)} className={css.inputsContainer}>
                            {(isError || login.error) && (
                                <span className={css.errorMessage}>
                                    Login failed: {error?.message ?? login.error?.message}
                                </span>
                            )}
                            <Input
                                {...register('email')}
                                required
                                type="email"
                                label="Email Address"
                                placeholder="you@example.com"
                            />
                            <PasswordInput
                                {...register('password')}
                                required
                                label="Password"
                                placeholder="Enter your password"
                            />
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <button type="button" className={css.register} onClick={() => navigate(registerPath)}>
                                    Register
                                </button>
                                <button
                                    type="button"
                                    className={css.forgotLink}
                                    style={{ height: '100%' }}
                                    onClick={() => navigate(resetPasswordPath)}
                                >
                                    Forgot password?
                                </button>
                            </Box>
                            <Button
                                type="submit"
                                isDisabled={login.isPending}
                                variant="primary"
                                isLoading={login.isPending}
                            >
                                Sign in
                            </Button>
                            <CommitSha />
                        </Stack>
                    </form>
                </Stack>
            </Card>
        </Page>
    );
}
